<template>
  <b-modal
    centered
    id="select-update-dialog"
    modal-class="overflow-hidden"
    title="Lưu ý"
    static
    scrollable
    @hidden="onHidden"
    v-model="showModalUpdate"
  >
    <p class="f14">Nhấn Xác nhận để duyệt!</p>
    <template #modal-footer="{ cancel }">
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <b-button variant="secondary" @click="cancel" class="mr-2"> Huỷ </b-button>
            <b-button variant="primary" @click="confirmApproveContract"> Xác nhận </b-button>
          </div>
        </div>
        <div v-if="messageWarning.length > 0 && (checked || checkedDuplicateGpkd)">
          <b-collapse
            id="collapse-4"
            v-model="isVisible"
            style="overflow-x: hidden; overflow-y: auto"
          >
            <div class="warning-wrapper">
              <b-card>
                <small
                  class="text-muted d-block mt-1"
                  v-for="(message, index) in messageWarning"
                  :key="index"
                >
                  {{ message }}
                </small>
              </b-card>
            </div>
          </b-collapse>
        </div>
      </div>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </b-modal>
</template>
<script>
  import { ContractService } from '@/services/contract.service'

  export default {
    props: {
      customerType: {
        type: String,
        default: '',
      },
      dataDetail: {
        type: Object,
      },
    },
    data() {
      return {
        showModalUpdate: false,
        showLoading: false,
        dataContract: {},
        customerInfoRes: {},
        customerId: null,
        checked: false,
        isVisible: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        messageWarning: [],
        checkedDuplicateGpkd: false,
        hasBusinessRegistrationNumber: false,
        appendixRunning: '',
      }
    },
    methods: {
      onHidden() {
        this.resetForm()
        this.showModalUpdate = false
      },
      resetForm() {
        this.messageWarning = []
        this.dataContract = {}
        this.customerInfoRes = {}
        this.customerId = null
        this.checked = false
        this.isVisible = false
      },
      checkAppendixWithCriteria(data) {
        const dataList = data?.appendixMultiFunctional || data?.lstAppendixMultiFunctional || []

        const matchingAppendix = dataList.find(appendix => {
          // Check if appendix has the required functionType
          const functionType = appendix.appendixMultiFunctional?.functionType
          const validFunctionTypes = ['ON_US_CV010425', 'VISA_SME_CV010425']

          // Check if functionType is one of the valid types and state is "SIGNED_WAITING_APPROVED"
          return (
            validFunctionTypes.includes(functionType) &&
            appendix.state === 'SIGNED_WAITING_APPROVED'
          )
        })

        // Return the appendixId if found, otherwise null
        return matchingAppendix ? matchingAppendix.appendixId : null
      },
      show(dataContract) {
        this.appendixRunning = this.checkAppendixWithCriteria(this.dataDetail)

        this.resetForm()
        this.showModalUpdate = true
        this.dataContract = dataContract ?? {}
        if (dataContract && dataContract.customerInfoRes) {
          this.customerInfoRes = dataContract.customerInfoRes
        } else if (dataContract && dataContract.customerInfoCommon) {
          this.customerInfoRes = dataContract.customerInfoCommon
        }
        if (dataContract && dataContract.customerId) {
          this.customerId = dataContract.customerId
        }
        this.checked = true
        this.checkDuplicateGpkd()
      },
      async checkDuplicateGpkd() {
        if (!this.checked) return
        try {
          this.showLoading = true
          this.isVisible = false
          this.messageWarning = []
          const params = {
            gpkd: this.customerInfoRes.businessRegistrationNumber ?? '',
            addressMc: this.customerInfoRes.address ?? '',
          }
          if (this.customerId) {
            params.customerId = this.customerId
          }

          const response = await ContractService.checkDuplicateGpkd(params)
          if (response.code === 1000) {
            const messageDuplicateGpkds =
              response.data && response.data.messageDuplicateGpkds
                ? response.data.messageDuplicateGpkds
                : []
            const messageDuplicateAddress =
              response.data && response.data.messageDuplicateAddress
                ? response.data.messageDuplicateAddress
                : []
            this.messageWarning = this.messageWarning.concat(
              messageDuplicateGpkds,
              messageDuplicateAddress
            )
            this.checkedDuplicateGpkd =
              response.data && response.data.hasOwnProperty('isDuplicateGpkd')
                ? response.data.isDuplicateGpkd
                : false
            this.checked = !this.checkedDuplicateGpkd
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      confirmApproveContract() {
        if (this.dataContract.formContract === 'E_CONTRACT') {
          this.approveContract()
        } else {
          this.actionToPaperContract()
        }
      },
      async approveContract() {
        try {
          this.showLoading = true
          let urlContractS3 = ''
          if (this.dataContract.typeCustomer !== 'COMPANY') {
            if (this.dataContract.signatureOfMerchantByContract.length > 0) {
              const response = await ContractService.genPDFByServer({
                token: this.dataUser.token,
                code: this.dataContract.code,
                groupService: this.dataContract.groupService,
              })
              if (response.code === 1000)
                urlContractS3 = `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/file/${response.message}`
            } else {
              this.showFailMx('Không có chữ ký hợp đồng')
            }
          }
          const params = {
            econtractId: this.dataContract.id,
            urlS3: urlContractS3,
            // hasBusinessRegistrationNumber: this.hasBusinessRegistrationNumber
          }
          // if (this.checked) {
          //   params.mcNewTPV = true
          // }
          const saveLink = await ContractService.saveLinkPFD(params)
          if (saveLink.code === 1000) {
            if (this.appendixRunning) {
              await this.actionToAppendix({
                appendixId: this.appendixRunning,
                appendixActionType: 'APPENDIX_ACTION_APPROVE',
              })
            }
            this.showSuccessMx('Duyệt HĐ thành công')
            this.$emit('approveContract', this.dataContract.id)
          } else {
            this.showFailMx(saveLink.message ?? saveLink.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
          this.showModalUpdate = false
        }
      },
      async actionToAppendix(params) {
        try {
          const response = await ContractService.actionAppendix(params)
          if (response.success) {
            // await this.getDetailContract()
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        }
      },
      async actionToPaperContract() {
        try {
          this.showLoading = true
          const params = {
            contractId: this.dataContract.id,
            paperActionType: 'PAPER_ACTION_APPROVE',
            // hasBusinessRegistrationNumber: this.hasBusinessRegistrationNumber
          }
          // if (this.checked) {
          //   params.mcNewTPV = true
          // }

          const response = await ContractService.actionPaperContract(params)
          console.log('response', response)

          if (response.success === true) {
            if (this.appendixRunning) {
              await this.actionToAppendix({
                appendixId: this.appendixRunning,
                appendixActionType: 'APPENDIX_ACTION_APPROVE',
              })
            }
            this.showSuccessMx('Duyệt HĐ thành công')
            this.$emit('approveContract', this.dataContract.id)
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
          this.showModalUpdate = false
        }
      },
    },
  }
</script>
<style scoped>
  .warning-wrapper {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .wrap-text {
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
    max-width: 250px;
    display: inline-block;
  }
</style>
